<template>
  <b-dropdown aria-role="list" variant="link" class="page-title text-bg-dark">
    <template #button-content>
      {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, new Intl.NumberFormat().format(itemCount), type]) }}
    </template>
    <b-dropdown-item v-for="s in sizeOptions" :key="s.value" :active="s.value === config.pageSize"
                     @click="setConfig('pageSize', s.value)">{{ s.text }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<style>
.page-title > button {
  color: #212529 !important;
  text-decoration: none !important;
}
</style>

<script>

export default {
  props: {
    type: {
      type: String,
      default: null
    },
    firstItemOfPage: {
      type: Number,
      default: 0
    },
    lastItemOfPage: {
      type: Number,
      default: 0
    },
    itemCount: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      key: `${this.type}_table_${this.$store.state.user._id}`,
      sizeOptions: [
        {value: 5, text: this.$t("displayRow", [5])},
        {value: 20, text: this.$t("displayRow", [20])},
        {value: 30, text: this.$t("displayRow", [30])},
        {value: 50, text: this.$t("displayRow", [50])},
        {value: 100, text: this.$t("displayRow", [100])},
        {value: 300, text: this.$t("displayRow", [300])},
        {value: 500, text: this.$t("displayRow", [500])},
      ],
      config: {
        pageSize: 50,
      }
    }
  },
  methods: {
    setData(key, value) {
      this.config[key] = value;
      localStorage.setItem(this.key, JSON.stringify(this.config));
    },
    setConfig(key, value) {
      this.setData(key, value);
      this.$emit('change', this.config);
    },
  },
  i18n: {
    messages: {
      en: {
        listSummary: "Showing {0}-{1}/{2} {3}",
        displayRow: "Display {0} lines",
      },
      vi: {
        listSummary: "Đang xem {0}-{1}/{2} {3}",
        displayRow: "Hiển thị {0} dòng",
      }
    }
  },
  mounted() {
    let store = localStorage.getItem(this.key);
    if (store) {
      this.config = Object.assign(this.config, JSON.parse(store));
    }
    this.$emit('change', this.config);
  }
}
</script>